/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingpreview1Inputs */

const en_listingpreview1 = /** @type {(inputs: Listingpreview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Preview`)
};

const de_listingpreview1 = /** @type {(inputs: Listingpreview1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau des Orts`)
};

/**
* | output |
* | --- |
* | "Listing Preview" |
*
* @param {Listingpreview1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingpreview1 = /** @type {((inputs?: Listingpreview1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingpreview1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingpreview1(inputs)
	return de_listingpreview1(inputs)
});
export { listingpreview1 as "listingPreview" }